module.exports = __webpack_public_path__ + "img/7.58fdd541.jpg";